import { render, staticRenderFns } from "./EnrollmentResult.vue?vue&type=template&id=61e0f9fc&scoped=true"
import script from "./EnrollmentResult.vue?vue&type=script&lang=js"
export * from "./EnrollmentResult.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentResult.vue?vue&type=style&index=0&id=61e0f9fc&prod&lang=stylus"
import style1 from "./EnrollmentResult.vue?vue&type=style&index=1&id=61e0f9fc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e0f9fc",
  null
  
)

export default component.exports